import {otsBaseApi} from "../../ots-api";
import {FlaggedMeter, FlaggedMeterSearchCriteria} from "../../../model/flagged-meter";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['FlaggedMeters']})

const flaggedMeterApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchFlaggedMeters: builder.query<FlaggedMeter[], FlaggedMeterSearchCriteria>({
      query: (arg) => ({
        url: `/meter/search/flagged`,
        method: 'POST',
        body: arg
      }),
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({meter}) => ({type: 'FlaggedMeters', id: meter.id} as const)),
            {type: 'FlaggedMeters', id: 'LIST'},
          ];
        } else {
          return [{type: 'FlaggedMeters', id: 'LIST'}];
        }
      },
    }),
  }),
})

export const {
  useSearchFlaggedMetersQuery,
} = flaggedMeterApi;
